import { SYSTEM_ROUTS } from '@/components/layout/routes/SystemRoutes.enum.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';

const pathsWithoutRedirect = [RouteEnum.ROOT, ...SYSTEM_ROUTS];

export const getKeycloakRedirectUrl = (
  keycloakRedirectUrl: string,
  pathname: string,
  search: string,
) => {
  if (pathsWithoutRedirect.includes(pathname)) {
    return keycloakRedirectUrl;
  }

  return `${keycloakRedirectUrl}?redirect=${encodeURIComponent(`${pathname}${search}`)}`;
};
